export class XrtSearchResponse {
  code: number;
  transactionTimestamp: Date;
  data: any; // TODO
}
